import * as types from './constants';

const initialState = {
  data: {},
  loading: false,
  errors_api: {}
};

const actions = {
  // Billing Subscription Portal
  [types.BILLING_SUBSCRIPTION_PORTAL_REQUEST]: state => {
    const data = {
      ...state,
      loading: true
    };

    return { ...data };
  },

  [types.BILLING_SUBSCRIPTION_PORTAL_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      data: payload,
      errors_api: {}
    };

    return { ...data };
  },

  [types.BILLING_SUBSCRIPTION_PORTAL_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      errors_api: payload
    };

    return { ...data };
  },

  [types.BILLING_SUBSCRIPTION_PORTAL_RESET]: () => {
    return { ...initialState };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};

